module.exports = __webpack_public_path__ + "img/art5.f6f643df.png";